import React from 'react'
import { Form } from 'rsuite'
import Icon from './Icon'
import Credits from './Credits'

// components
import SideDrawer from './SideDrawer'
import YouForm from './YouForm'
import RaceOptions from './RaceOptions'
import FavouritesForm from './FavouritesForm'
import NotifyOptions from './NotifyOptions'
import DisplayOptions from './DisplayOptions'


const OptionsDrawer = ( { show = false, onClose } ) =>
{
  return (
    <SideDrawer show={ show } onClose={ onClose } icon="avatar" title="Your preferences">
      <Form.Group className="you">
        <Form.ControlLabel><Icon icon="car"/> Your registration number</Form.ControlLabel>
        <YouForm onClose={ onClose }/>
      </Form.Group>
      <Form.Group className="favourites">
        <Form.ControlLabel><Icon icon="star"/> Favourites</Form.ControlLabel>
        <FavouritesForm/>
      </Form.Group>
      <RaceOptions onClose={ onClose }/>
      <Form.Group className="display">
        <Form.ControlLabel><Icon icon="eye"/> Display charts &amp; graphs</Form.ControlLabel>
        <DisplayOptions/>
      </Form.Group>
      <Form.Group className="notifications">
        <Form.ControlLabel><Icon icon="bell"/> In-app notifications</Form.ControlLabel>
        <NotifyOptions/>
      </Form.Group>
      { /* a group of its own, for the line above it like between the other groups */ }
      <Form.Group className="credits">
        <Credits/>
      </Form.Group>
    </SideDrawer>
  )
}

export default OptionsDrawer
